import React, {useEffect, useState} from "react";
import {Box, Grid, Typography} from "@mui/material";
import TenantAppCard from "./TenantAppCard";
import {axios_tenant} from "../../../axios";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";

const TenantAppList = () => {
    const navigate = useNavigate();

    const location = useLocation();

    const { search } = useSelector(state => ({ ...state }));
    let { text } = search;

    const [appData, setAppData] = useState([]);
  const [loading, setLoading] = useState(false);

    let dispatch = useDispatch();

    const searched = keyword => c => c.app_name.toLowerCase().includes(keyword);

    useEffect(() => {
        dispatch({
            type: "SEARCH_QUERY",
            payload: { text: "" }
        });
        getActiveApps();
    }, [location.pathname]);

    const getActiveApps = () => {
      setLoading(true);
        axios_tenant
        .get("/apps/activeApps")
            .then(res => {
              setLoading(false);
                setAppData(res.data);
            })
            .catch(err => {
              setLoading(false);
            });
    };

    //  ////

    return (
        <React.Fragment>
            <Grid container >
              {loading ?
                <Typography>Loading...</Typography> :

                (appData && appData.length === 0 ? (
                        <Typography variant="h3" color="black">
                            {" "}
                          No apps subscribed
                        </Typography>
                    ) : (
                      <>
                      {location.pathname.includes("dashboard")&& localStorage.getItem("tenant_username") &&
                      <Box sx={{marginLeft: '15%', marginRight: '15%', marginBottom:'1%', display:"flex",alignItems:"flex-end"}}>

                       <Typography variant="h5" sx={{fontSize:"1.5rem",fontFamily:"Lato", color: "#333333"}}>
                        {`Hello ${localStorage.getItem("tenant_username").split(" ")[0]},`}
                       </Typography>
                       &nbsp;
                       &nbsp;
                       <Typography variant="h5" sx={{fontSize:"1.5rem", fontFamily:"Lato",color: "#333333"}}>Welcome to the TREXO Platform</Typography>
                       </Box>
                       }
                      <Grid container justifyContent="center" sx={{marginLeft: '15%', marginRight: '15%' }} >
                        {appData?.filter(searched(text.toLowerCase()))?.map((p, i) => (
                            <Grid item key={p.app_id} xs={12} sm={3} md={4} lg={4} style={{marginBottom:"3.5%"}}>  
                                <TenantAppCard p={p} />
                            </Grid>
                        ))}
                        </Grid>
                        </>
                    )
                )
              }
            </Grid>
        </React.Fragment>
    );
};

export default TenantAppList;
